module.exports = __webpack_public_path__ + "img/user.d87c3512.jpg";